<div [ngClass]="{ 'container-fluid mt-2': !modal}">
  <div [ngClass]="{ 'p-4 rounded': !modal }">
    <div class="row justify-content-center" *ngIf="!modal">
      <h5 class="title_section text-secondary">Solicitud de evaluación para capacidad de pago - Persona natural</h5>
      <!-- Separador -->
      <hr width="90%">
    </div>
    <form [formGroup]="forma" (ngSubmit)="registrar()">
      <!-- <div class="row justify-content-end">
        <div class="col-sm-12 col-md-6 col-lg-3">
          <div class="form-group text-left" [ngClass]="{ 'text-danger': startDate.invalid && startDate.touched }">
            <label class="col-form-label col-form-label-sm">Día / Mes / Año</label>
            <div class="input-group">
              <input type="text" class="form-control form-control-sm text-center" ngbDatepicker #d1="ngbDatepicker" (click)="d1.toggle()" placeholder="Día/Mes/Año" [minDate]="hoy" [maxDate]="hoy" readonly formControlName="startDate">
              <div class="input-group-append">
                <button class="btn btn-info btn-sm" (click)="d1.toggle()" type="button"><i class="fa fa-calendar"></i></button>
              </div>
            </div>
            <div *ngIf="startDate.errors && (startDate.dirty || startDate.touched)">
              <span *ngIf="startDate.errors.required">Requerido</span>
            </div>
          </div>
        </div>
      </div> -->
      <div class="row justify-content-center">
        <!-- <div class="col-sm-12 col-md-4 col-lg-2">
          <div class="form-group" [ngClass]="{ 'text-danger': transfer.invalid && transfer.touched }">
            <label class="col-form-label col-form-label-sm">Cesión</label>
            <ng-select
              class="custom"
              readonly="true"
              [loading]="loadValues"
              loadingText="Cargando por favor espere..."
              placeholder="Selecciona"
              [clearable]="false"
              [searchable]="false"
              formControlName="transfer">
              <ng-option value="Si">Si</ng-option>
              <ng-option value="No">No</ng-option>
            </ng-select>
            <div *ngIf="transfer.errors && (transfer.dirty || transfer.touched)">
              <span *ngIf="transfer.errors.required">Requerido</span>
            </div>
          </div>
        </div> -->
        <div class="col-sm-12 col-md-4 col-lg-2">
          <div class="form-group text-left" [ngClass]="{ 'text-danger': startDate.invalid && startDate.touched }">
            <label class="col-form-label col-form-label-sm">Fecha diligenciamiento</label>
            <div class="input-group">
              <input type="text" class="form-control form-control-sm text-center" ngbDatepicker #d1="ngbDatepicker" (click)="d1.toggle()" placeholder="Día/Mes/Año" [minDate]="hoy" [maxDate]="hoy" readonly formControlName="startDate">
              <div class="input-group-append">
                <button class="btn btn-info btn-sm" (click)="d1.toggle()" type="button" disabled><i class="fa fa-calendar"></i></button>
              </div>
            </div>
            <div *ngIf="startDate.errors && (startDate.dirty || startDate.touched)">
              <span *ngIf="startDate.errors.required">Requerido</span>
            </div>
          </div>
        </div>
        <!-- <div class="col-sm-12 col-md-4 col-lg-2">
          <div class="form-group" [ngClass]="{ 'text-danger': role.invalid && role.touched }">
            <label class="col-form-label col-form-label-sm">Rol</label>
            <ng-select
              [items]="tr"
              bindValue="valueId"
              bindLabel="name"
              class="custom"
              [virtualScroll]="true"
              [readonly]="preLoad"
              [loading]="loadValues"
              loadingText="Cargando por favor espere..."
              placeholder="Selecciona"
              [clearable]="false"
              [searchable]="false"
              formControlName="role">
            </ng-select>
            <div *ngIf="role.errors && (role.dirty || role.touched)">
              <span *ngIf="role.errors.required">Requerido</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-2">
          <div class="form-group" [ngClass]="{ 'text-danger': debtor.invalid && debtor.touched }">
            <label class="col-form-label col-form-label-sm">Deudor</label>
            <ng-select
              [items]="tp"
              bindValue="valueId"
              bindLabel="name"
              class="custom"
              [virtualScroll]="true"
              [readonly]="preLoad"
              [loading]="loadValues"
              loadingText="Cargando por favor espere..."
              placeholder="Selecciona"
              [clearable]="false"
              [searchable]="false"
              formControlName="debtor">
            </ng-select>
            <div *ngIf="debtor.errors && (debtor.dirty || debtor.touched)">
              <span *ngIf="debtor.errors.required">Requerido</span>
            </div>
          </div>
        </div> -->
        <div class="col-sm-12 col-md-6 col-lg-3">
          <div class="form-group" [ngClass]="{ 'text-danger': contractNumber.invalid && contractNumber.touched }">
            <label class="col-form-label col-form-label-sm">Contrato</label>
            <input type="text" class="form-control form-control-sm" [readonly]="adjudgedInfo?.quotaNumber" formControlName="contractNumber" [imask]="contractMask" placeholder="000-0000000">
            <div *ngIf="contractNumber.errors && (contractNumber.dirty || contractNumber.touched)">
              <span *ngIf="contractNumber.errors.required">Requerido</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <div class="form-group" [ngClass]="{ 'text-danger': quotaNumber.invalid && quotaNumber.touched }">
            <label class="col-form-label col-form-label-sm">Cupo (Grupo, Afiliación nivel)</label>
            <input type="text" class="form-control form-control-sm" [readonly]="adjudgedInfo?.contractNumber" formControlName="quotaNumber" [imask]="quotaMask" placeholder="0000000000-0">
            <div *ngIf="quotaNumber.errors && (quotaNumber.dirty || quotaNumber.touched)">
              <span *ngIf="quotaNumber.errors.required">Requerido</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div id="accordion" role="tablist"> -->
        <!-- <div class="card"> -->
          <div class="card-header" role="tab" id="tituloSolicitante" data-toggle="collapse" data-target="#infoSolicitante" aria-expanded="false" aria-controls="infoSolicitante">
            <h4 class="mb-0">Información del solicitante</h4>
          </div>
          <div id="infoSolicitante" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloSolicitante">
            <div class="row">
              <div class="col-12">
                <div class="alert alert-info" role="alert">
                  <i class="fa fa-info-circle"></i> <strong>Nota:</strong> Si tus datos no están correctos por favor comunícate con nuestras líneas de atención y actualiza tus datos.
                </div>
              </div>
            </div>
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': name.invalid && name.touched }">
                  <label class="col-form-label col-form-label-sm">Nombre completo</label>
                  <input type="text" class="form-control form-control-sm" formControlName="name" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)" readonly>
                  <div *ngIf="name.errors && (name.dirty || name.touched)">
                    <span *ngIf="name.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': lastName.invalid && lastName.touched }">
                  <label class="col-form-label col-form-label-sm">Primer apellido</label>
                  <input type="text" class="form-control form-control-sm" formControlName="lastName" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)" readonly>
                  <div *ngIf="lastName.errors && (lastName.dirty || lastName.touched)">
                    <span *ngIf="lastName.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': surname.invalid && surname.touched }">
                  <label class="col-form-label col-form-label-sm">Segundo apellido</label>
                  <input type="text" class="form-control form-control-sm" formControlName="surname" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)" readonly>
                  <!--<div *ngIf="surname.errors && (surname.dirty || surname.touched)">
                    <span *ngIf="surname.errors.required">Requerido</span>
                  </div>-->
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': documentNumber.invalid && documentNumber.touched }">
                  <label class="col-form-label col-form-label-sm">No. identificación</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <ng-select
                        [items]="td"
                        bindValue="valueId"
                        bindLabel="valueId"
                        class="custom"
                        [loading]="loadValues"
                        loadingText="Cargando por favor espere..."
                        [clearable]="false"
                        [searchable]="false"
                        [readonly]="true"
                        formControlName="typeOfIdentity">
                      </ng-select>
                    </div>
                    <input type="text" class="form-control form-control-sm" formControlName="documentNumber" [imask]="onlyNumberMask" (blur)="saveForm(forma, formIdentifier)" readonly>
                  </div>
                  <div *ngIf="documentNumber.errors && (documentNumber.dirty || documentNumber.touched)">
                    <span *ngIf="documentNumber.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 2 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': expeditionDate.invalid && expeditionDate.touched }">
                  <label class="col-form-label col-form-label-sm">Fecha de expedición</label>
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm text-center" ngbDatepicker #d2="ngbDatepicker"
                    (click)="d2.toggle()"
                           placeholder="Día/Mes/Año" [minDate]="minDate" [maxDate]="hoy" readonly formControlName="expeditionDate" (blur)="saveForm(forma, formIdentifier)">
                    <div class="input-group-append">
                      <button class="btn btn-info btn-sm" (click)="d2.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                    </div>
                  </div>
                  <div *ngIf="expeditionDate.errors && (expeditionDate.dirty || expeditionDate.touched)">
                    <span *ngIf="expeditionDate.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': expeditionDepartment.invalid && expeditionDepartment.touched }">
                  <label class="col-form-label col-form-label-sm">Departamento de expedición</label>
                  <ng-select
                    (change)="c10 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="expeditionDepartment"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="expeditionDepartment.errors && (expeditionDepartment.dirty || expeditionDepartment.touched)">
                    <span *ngIf="expeditionDepartment.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': expeditionCity.invalid && expeditionCity.touched }">
                  <label class="col-form-label col-form-label-sm">Ciudad de expedición</label>
                  <ng-select
                    [items]="c10"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!expeditionDepartment.value"
                    [loading]="c10?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="expeditionCity"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="expeditionCity.errors && (expeditionCity.dirty || expeditionCity.touched)">
                    <span *ngIf="expeditionCity.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <!-- <label class="col-form-label col-form-label-sm d-sm-none d-lg-block">&nbsp;</label> -->
                <div class="form-group" [ngClass]="{ 'text-danger': sex.invalid && sex.touched }">
                  <label class="col-form-label col-form-label-sm">Género</label>
                  <ng-select
                    [items]="s"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="sex"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="sex.errors && (sex.dirty || sex.touched)">
                    <span *ngIf="sex.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 3 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <!-- <label class="col-form-label col-form-label-sm d-sm-none d-lg-block">&nbsp;</label> -->
                <div class="form-group" [ngClass]="{ 'text-danger': dateOfBirth.invalid && dateOfBirth.touched }">
                  <label class="col-form-label col-form-label-sm">Fecha de nacimiento</label>
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm text-center" ngbDatepicker #d3="ngbDatepicker" (click)="d3.toggle()" placeholder="Día/Mes/Año" [minDate]="minDate" [maxDate]="hoy" readonly formControlName="dateOfBirth" (blur)="saveForm(forma, formIdentifier)">
                    <div class="input-group-append">
                      <button class="btn btn-info btn-sm" (click)="d3.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                    </div>
                  </div>
                  <div *ngIf="dateOfBirth.errors && (dateOfBirth.dirty || dateOfBirth.touched)">
                    <span *ngIf="dateOfBirth.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': nationality.invalid && nationality.touched }">
                  <label class="col-form-label col-form-label-sm">Nacionalidad</label>
                  <ng-select
                    [items]="n"
                    class="custom"
                    bindValue="valueId"
                    bindLabel="name"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="nationality"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="nationality.errors && (nationality.dirty || nationality.touched)">
                    <span *ngIf="nationality.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': civilStatus.invalid && civilStatus.touched }">
                  <label class="col-form-label col-form-label-sm">Estado civil</label>
                  <ng-select
                    [items]="ec"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="civilStatus"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="civilStatus.errors && (civilStatus.dirty || civilStatus.touched)">
                    <span *ngIf="civilStatus.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': academicLevel.invalid && academicLevel.touched }">
                  <label class="col-form-label col-form-label-sm">Nivel académico</label>
                  <ng-select
                    [items]="na"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="academicLevel"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="academicLevel.errors && (academicLevel.dirty || academicLevel.touched)">
                    <span *ngIf="academicLevel.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 4 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="+academicLevel.value != 8">
                <div class="form-group" [ngClass]="{ 'text-danger': profession.invalid && profession.touched }">
                  <label class="col-form-label col-form-label-sm">Profesión</label>
                  <ng-select
                    [items]="p"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [readonly]="+academicLevel.value < 3"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="profession"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="profession.errors && (profession.dirty || profession.touched)">
                    <span *ngIf="profession.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="+profession.value == 26 || +academicLevel.value == 8">
                <div class="form-group" [ngClass]="{ 'text-danger': otherProfession.invalid && otherProfession.touched }">
                  <label class="col-form-label col-form-label-sm">¿Cuál?</label>
                  <input type="text" class="form-control form-control-sm" [imask]="wordMask" formControlName="otherProfession" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="otherProfession.errors && (otherProfession.dirty || otherProfession.touched)">
                    <span *ngIf="otherProfession.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group row" [ngClass]="{ 'text-danger': (minorLoad.invalid && minorLoad.touched) || (higherLoad.invalid && higherLoad.touched) }">
                  <label class="col-12 col-form-label col-form-label-sm">Número de personas a cargo</label>
                  <div class="col-6">
                    <ng-select
                      [items]="n15"
                      class="custom"
                      [loading]="loadValues"
                      loadingText="Cargando por favor espere..."
                      placeholder="menor de 18"
                      [clearable]="false"
                      [searchable]="false"
                      formControlName="minorLoad"
                      (blur)="saveForm(forma, formIdentifier)">
                    </ng-select>
                    <div *ngIf="minorLoad.errors && (minorLoad.dirty || minorLoad.touched)">
                      <span *ngIf="minorLoad.errors.required">Requerido</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <ng-select
                      [items]="n15"
                      class="custom"
                      [loading]="loadValues"
                      loadingText="Cargando por favor espere..."
                      placeholder="mayor de 18"
                      [clearable]="false"
                      [searchable]="false"
                      formControlName="higherLoad"
                      (blur)="saveForm(forma, formIdentifier)">
                    </ng-select>
                    <div *ngIf="higherLoad.errors && (higherLoad.dirty || higherLoad.touched)">
                      <span *ngIf="higherLoad.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': housing.invalid && housing.touched }">
                  <label class="col-form-label col-form-label-sm">Tipo de vivienda</label>
                  <ng-select
                    [items]="tv"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="housing"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="housing.errors && (housing.dirty || housing.touched)">
                    <span *ngIf="housing.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': rent.invalid && rent.touched }">
                  <label class="col-form-label col-form-label-sm">Declara renta</label>
                  <ng-select
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="rent"
                    (blur)="saveForm(forma, formIdentifier)">
                    <ng-option value="Si">Si</ng-option>
                    <ng-option value="No">No</ng-option>
                  </ng-select>
                  <div *ngIf="rent.errors && (rent.dirty || rent.touched)">
                    <span *ngIf="rent.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <app-direccion
              (direction)="addressConstructed($event)"
              [direccion]="adjudged?.address"
              [editable]="true"
              [address]="forma.controls.address"
              [id]="'address'"
              [oneField]="true"
              [size]="true">
            </app-direccion>
            <!-- Fila 5 -->
            <div class="row">
              <!-- <div class="col-sm-12 col-md-6 col-lg-3"> -->
                <!-- <div class="form-group" [ngClass]="{ 'text-danger': address.invalid && address.touched }">
                  <label class="col-form-label col-form-label-sm">Dirección de residencia</label>
                  <input type="text" class="form-control form-control-sm" [readonly]="adjudged?.address" formControlName="address">
                  <div *ngIf="address.errors && (address.dirty || address.touched)">
                    <span *ngIf="address.errors.required">Requerido</span>
                  </div>
                </div> -->

              <!-- </div> -->
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': country.invalid && country.touched }">
                  <label class="col-form-label col-form-label-sm">País</label>
                  <ng-select
                    [items]="paises"
                    bindValue="name"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="true"
                    formControlName="country"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="country.errors && (country.dirty || country.touched)">
                    <span *ngIf="country.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': department.invalid && department.touched }">
                  <label class="col-form-label col-form-label-sm">Departamento</label>
                  <ng-select
                    (change)="c1 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="department"
                    [readonly]="country.value !== 'Colombia'"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="department.errors && (department.dirty || department.touched)">
                    <span *ngIf="department.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div *ngIf="country.value === 'Colombia'; else otherCities" class="form-group" [ngClass]="{ 'text-danger': city.invalid && city.touched }">
                  <label class="col-form-label col-form-label-sm">Ciudad</label>
                  <ng-select
                    (change)="l1 = $event ? $event.localities : null"
                    [items]="c1"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="city"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="city.errors && (city.dirty || city.touched)">
                    <span *ngIf="city.errors.required">Requerido</span>
                  </div>
                </div>
                <ng-template #otherCities>
                  <div class="form-group" [ngClass]="{ 'text-danger': cityOtherCountries.invalid && cityOtherCountries.touched }">
                    <label class="col-form-label col-form-label-sm">Ciudad</label>
                    <input type="text" class="form-control form-control-sm" formControlName="cityOtherCountries" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                    <div *ngIf="cityOtherCountries.errors && (cityOtherCountries.dirty || cityOtherCountries.touched)">
                      <span *ngIf="cityOtherCountries.errors.required">Requerido</span>
                    </div>
                  </div>
                </ng-template>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': location.invalid && location.touched }">
                  <label class="col-form-label col-form-label-sm">Localidad</label>
                  <ng-select
                    [items]="l1"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!city.value || l1?.length === 0 || adjudged?.ubication?.locationId"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="location"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="location.errors && (location.dirty || location.touched)">
                    <span *ngIf="location.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 6 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': stratum.invalid && stratum.touched }">
                  <label class="col-form-label col-form-label-sm">Estrato</label>
                  <ng-select
                    [items]="ese"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="stratum"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="stratum.errors && (stratum.dirty || stratum.touched)">
                    <span *ngIf="stratum.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': yearsResidence.invalid && yearsResidence.touched }">
                  <label class="col-form-label col-form-label-sm">Años en la residencia</label>
                  <ng-select
                    [items]="ar"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="yearsResidence"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="yearsResidence.errors && (yearsResidence.dirty || yearsResidence.touched)">
                    <span *ngIf="yearsResidence.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': phone.invalid && phone.touched }">
                  <label class="col-form-label col-form-label-sm">Teléfono</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="phoneMask" [unmask]="true" formControlName="phone" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="phone.errors && (phone.dirty || phone.touched)">
                    <span *ngIf="phone.errors.required">Requerido</span>
                    <span *ngIf="phone.errors.minlength">El número de teléfono debe contener 10 dígitos</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': cellular.invalid && cellular.touched }">
                  <label class="col-form-label col-form-label-sm">Celular</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="cellularMask" [unmask]="true" formControlName="cellular" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="cellular.errors && (cellular.dirty || cellular.touched)">
                    <span *ngIf="cellular.errors.required">Requerido</span>
                    <span *ngIf="cellular.errors.minlength">El número de celular debe contener 10 dígitos</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 7 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': email.invalid && email.touched }">
                  <label class="col-form-label col-form-label-sm">Correo electrónico <sup><strong>1</strong></sup></label>
                  <input type="text" class="form-control form-control-sm" [pattern]="emailPattern" onkeypress="return event.charCode != 32" formControlName="email" readonly (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="email.errors && (email.dirty || email.touched)">
                    <span *ngIf="email.errors.required">Requerido</span>
                    <span *ngIf="email.errors.pattern || email.errors.email">Formato email incorrecto</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': emailAlt.invalid && emailAlt.touched }">
                  <label class="col-form-label col-form-label-sm">Correo electrónico alternativo</label>
                  <input type="text" class="form-control form-control-sm" [pattern]="emailPattern" onkeypress="return event.charCode != 32" formControlName="emailAlt" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="emailAlt.errors && (emailAlt.dirty || emailAlt.touched)">
                    <span *ngIf="emailAlt.errors.pattern || emailAlt.errors.email">Formato email incorrecto</span>
                    <span *ngIf="emailAlt.errors.fieldsAreEqual">El email alternativo no puede ser igual al principal</span>
                  </div>
                </div>
              </div>
              <div class="col-12 info">
                <sup><strong>1</strong></sup><sub class="f-size"> Autorizo el envio de mi extracto e información relacionada con el Plan a la dirección eletrónica por mi informada.</sub>
                <!-- <div *ngIf="email.value != null && name.value != null && lastName.value != null && documentNumber.value != null
                  && expeditionDate.value != null && expeditionDepartment.value != null && expeditionCity.value != null && sex.value != null
                  && dateOfBirth.value != null && nationality.value != null && civilStatus.value != null && academicLevel.value != null
                  && minorLoad.value != null && higherLoad.value != null && housing.value != null && rent.value != null && address.value != null
                  && country.value != null && department.value != null && city.value != null && stratum.value != null
                  && yearsResidence.value != null && phone.value != null && cellular.value != null"
                  class=" lb-success card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                </div>
                <div *ngIf="email.value == null || name.value == null || lastName.value == null || documentNumber.value == null
                  || expeditionDate.value == null || expeditionDepartment.value == null || expeditionCity.value == null || sex.value == null
                  || dateOfBirth.value == null || nationality.value == null || civilStatus.value == null || academicLevel.value == null
                  || minorLoad.value == null || higherLoad.value == null || housing.value == null || rent.value == null || address.value == null
                  || country.value == null || department.value == null || city.value == null || stratum.value == null
                  || yearsResidence.value == null || phone.value == null || cellular.value == null"
                  class=" lb-success card-footer text-white" style="text-align: right;" class=" lb-process card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div> -->
                <!-- || !expeditionDate.value  || !dateOfBirth.value || !address.value ||  -->
                <div class="text-right lb-process card-footer text-white" *ngIf="(!name.value || !lastName.value || !typeOfIdentity.value || !documentNumber.value || !expeditionDepartment.value || !expeditionCity.value || !sex.value || !nationality.value || !civilStatus.value || !academicLevel.value || (['4', '5', '6'].includes(academicLevel?.value) && !profession.value) || minorLoad.value === null || higherLoad.value === null || !housing.value || !rent.value || !country.value || (!department.value && country.value === 'Colombia') || (!city.value && country.value === 'Colombia') || (!cityOtherCountries.value && country.value !== 'Colombia') || !stratum.value || !yearsResidence.value || !phone.value || !cellular.value || !email.value || !expeditionDate.value || (!profession.value && profession.invalid) || (!otherProfession.value && otherProfession.invalid) || !address.get('inlineAddress').value); else sc_is">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div>
                <ng-template #sc_is>
                  <div class="text-right lb-success card-footer text-white">
                    <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloConyuge" data-toggle="collapse" data-target="#infoConyuge" aria-expanded="false" aria-controls="infoConyuge" *ngIf="civilStatus.value === 'C' || civilStatus.value === 'U'">
            <h4 class="mb-0">Datos del cónyuge</h4>
          </div>
          <div id="infoConyuge" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloConyuge" *ngIf="civilStatus.value === 'C' || civilStatus.value === 'U'">
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': name1.invalid && name1.touched }">
                  <label class="col-form-label col-form-label-sm">Nombre completo</label>
                  <input type="text" class="form-control form-control-sm" formControlName="name1" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="name1.errors && (name1.dirty || name1.touched)">
                    <span *ngIf="name1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': lastName1.invalid && lastName1.touched }">
                  <label class="col-form-label col-form-label-sm">Primer apellido</label>
                  <input type="text" class="form-control form-control-sm" formControlName="lastName1" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="lastName1.errors && (lastName1.dirty || lastName1.touched)">
                    <span *ngIf="lastName1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': surname1.invalid && surname1.touched }">
                  <label class="col-form-label col-form-label-sm">Segundo apellido</label>
                  <input type="text" class="form-control form-control-sm" formControlName="surname1" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="surname1.errors && (surname1.dirty || surname1.touched)">
                    <span *ngIf="surname1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': documentNumber1.invalid && documentNumber1.touched }">
                  <label class="col-form-label col-form-label-sm">No. identificación</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <ng-select
                        [items]="td"
                        bindValue="valueId"
                        bindLabel="valueId"
                        class="custom"
                        [loading]="loadValues"
                        loadingText="Cargando por favor espere..."
                        [clearable]="false"
                        [searchable]="false"
                        formControlName="typeOfIdentity1">
                      </ng-select>
                    </div>
                    <input type="text" class="form-control form-control-sm" formControlName="documentNumber1" [imask]="onlyNumberMask" (blur)="saveForm(forma, formIdentifier)">
                  </div>
                  <div *ngIf="documentNumber1.errors && (documentNumber1.dirty || documentNumber1.touched)">
                    <span *ngIf="documentNumber1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 2 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group text-left" [ngClass]="{ 'text-danger': dateOfBirth1.invalid && dateOfBirth1.touched }">
                  <label class="col-form-label col-form-label-sm">Fecha de nacimiento</label>
                  <div class="input-group">
                    <input type="text" class="form-control form-control-sm text-center" ngbDatepicker #d4="ngbDatepicker"
                    (click)="d4.toggle()" placeholder="Día/Mes/Año" [minDate]="minDate"
                    [maxDate]="hoy18" readonly formControlName="dateOfBirth1" (blur)="saveForm(forma, formIdentifier)">
                    <div class="input-group-append">
                      <button class="btn btn-info btn-sm" (click)="d4.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                    </div>
                  </div>
                  <div *ngIf="dateOfBirth1.errors && (dateOfBirth1.dirty || dateOfBirth1.touched)">
                    <span *ngIf="dateOfBirth1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': sex1.invalid && sex1.touched }">
                  <label class="col-form-label col-form-label-sm">Género</label>
                  <ng-select
                    [items]="s"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="sex1"
                    placeholder="Selecciona"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="sex1.errors && (sex1.dirty || sex1.touched)">
                    <span *ngIf="sex1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': chevyPlan1.invalid && chevyPlan1.touched }">
                  <label class="col-form-label col-form-label-sm info1 mb-1">¿Tiene relación con ChevyPlan, GM, Concesionario?</label>
                  <ng-select
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="chevyPlan1"
                    placeholder="Selecciona"
                    (blur)="saveForm(forma, formIdentifier)">
                    <ng-option value="Si">Si</ng-option>
                    <ng-option value="No">No</ng-option>
                  </ng-select>
                  <div *ngIf="chevyPlan1.errors && (chevyPlan1.dirty || chevyPlan1.touched)">
                    <span *ngIf="chevyPlan1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <!-- <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': address1.invalid && address1.touched }">
                  <label class="col-form-label col-form-label-sm">Dirección de residencia</label>
                  <input type="text" class="form-control form-control-sm" formControlName="address1">
                  <div *ngIf="address1.errors && (address1.dirty || address1.touched)">
                    <span *ngIf="address1.errors.required">Requerido</span>
                  </div>
                </div>
              </div> -->
            </div>
            <app-direccion
              (direction)="addressConstructed($event)"
              [editable]="true"
              [address]="forma.controls.address1"
              [id]="'address1'">
            </app-direccion>
            <!-- Fila 3 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': department1.invalid && department1.touched }">
                  <label class="col-form-label col-form-label-sm">Departamento</label>
                  <ng-select
                    (change)="c2 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="department1"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="department1.errors && (department1.dirty || department1.touched)">
                    <span *ngIf="department1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': city1.invalid && city1.touched }">
                  <label class="col-form-label col-form-label-sm">Ciudad</label>
                  <ng-select
                    (change)="l2 = $event ? $event.localities : null"
                    [items]="c2"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!department1.value"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="city1"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="city1.errors && (city1.dirty || city1.touched)">
                    <span *ngIf="city1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': location1.invalid && location1.touched }">
                  <label class="col-form-label col-form-label-sm">Localidad</label>
                  <ng-select
                    [items]="l2"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!city1.value || l2?.length === 0"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="location1"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="location1.errors && (location1.dirty || location1.touched)">
                    <span *ngIf="location1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': phone1.invalid && phone1.touched }">
                  <label class="col-form-label col-form-label-sm">Teléfono</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="phoneMask" [unmask]="true" formControlName="phone1" minlength="7" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="phone1.errors && (phone1.dirty || phone1.touched)">
                    <span *ngIf="phone1.errors.required">Requerido</span>
                    <span *ngIf="phone1.errors?.minlength">
                      El número de teléfono debe contener 10 dígitos
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 4 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': cellular1.invalid && cellular1.touched }">
                  <label class="col-form-label col-form-label-sm">Celular</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="cellularMask" [unmask]="true" formControlName="cellular1" minlength="10" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="cellular1.errors && (cellular1.dirty || cellular1.touched)">
                    <span *ngIf="cellular1.errors.required">Requerido</span>
                    <span *ngIf="cellular1.errors?.minlength">
                      El número de celular debe contener 10 dígitos
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': activities1.invalid && activities1.touched }">
                  <label class="col-form-label col-form-label-sm">Actividad</label>
                  <input type="text" class="form-control form-control-sm" formControlName="activities1" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="activities1.errors && (activities1.dirty || activities1.touched)">
                    <span *ngIf="activities1.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-12 info">
                <div *ngIf="name1.value != null && lastName1.value != null && documentNumber1.value != null && dateOfBirth1.value != null
                  && sex1.value != null && chevyPlan1.value != null && address1.valid && department1.value != null
                  && city1.value != null && phone1.value != null && cellular1.value != null && activities1.value != null"
                  class="lb-success card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                </div>
                <div *ngIf="name1.value == null || lastName1.value == null || documentNumber1.value == null || dateOfBirth1.value == null
                || sex1.value == null || chevyPlan1.value == null || !address1.valid || department1.value == null
                || city1.value == null || phone1.value == null || cellular1.value == null || activities1.value == null"
                  class="lb-success card-footer text-white" style="text-align: right;" class=" lb-process card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloActividad" data-toggle="collapse" data-target="#infoActividad" aria-expanded="false" aria-controls="infoActividad">
            <h4 class="mb-0">Actividad económica principal del solicitante</h4>
          </div>
          <div id="infoActividad" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloActividad">
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': job.invalid && job.touched }">
                  <label class="col-form-label col-form-label-sm">Actividad</label>
                  <ng-select
                    [items]="emp"
                    bindValue="valueId"
                    bindLabel="name"
                    (change)="initFormAdress32()"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="job"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="job.errors && (job.dirty || job.touched)">
                    <span *ngIf="job.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': ciiu.invalid && ciiu.touched }">
                  <label class="col-form-label col-form-label-sm">Código CIIU</label>
                  <ng-select
                    [items]="ci"
                    bindValue="valueId"
                    bindLabel="valueId"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="ciiu"
                    (blur)="saveForm(forma, formIdentifier)">
                   <ng-option *ngFor="let x of ci" [value]="x.valueId">{{x.valueId}}</ng-option>
                  </ng-select>
                  <div *ngIf="ciiu.errors && (ciiu.dirty || ciiu.touched)">
                    <span *ngIf="ciiu.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="job.value === '7'">
                <div class="form-group" [ngClass]="{ 'text-danger': whichJob.invalid && whichJob.touched }">
                  <label class="col-form-label col-form-label-sm">¿Cuál?</label>
                  <input type="text" class="form-control form-control-sm" [imask]="wordMask" [readonly]="job.value !== '7'" formControlName="whichJob" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="whichJob.errors && (whichJob.dirty || whichJob.touched)">
                    <span *ngIf="whichJob.errors.required">Indique cuál</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="job.value !== '7'">
                <div class="form-group" [ngClass]="{ 'text-danger': business.invalid && business.touched }">
                  <label class="col-form-label col-form-label-sm">Nombre de la empresa/negocio</label>
                  <input type="text" class="form-control form-control-sm" [imask]="wordMask" formControlName="business" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="business.errors && (business.dirty || business.touched)">
                    <span *ngIf="business.errors.required">Requedido</span>
                  </div>
                </div>
              </div>
              <!-- *ngIf="business.value"-->
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': antiquity.invalid && antiquity.touched }">
                  <label class="col-form-label col-form-label-sm">Antigüedad laboral</label>
                  <ng-select
                    [items]="ar"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="antiquity"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="antiquity.errors && (antiquity.dirty || antiquity.touched)">
                    <span *ngIf="antiquity.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="business.value || job.value === '1' || job.value === '6'">
                <div class="form-group" [ngClass]="{ 'text-danger': position.invalid && position.touched }">
                  <label class="col-form-label col-form-label-sm">Cargo</label>
                  <ng-select
                    [items]="ca"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="position"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="position.errors && (position.dirty || position.touched)">
                    <span *ngIf="position.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="position.value === '32'">
                <div class="form-group" [ngClass]="{ 'text-danger': whichPosition.invalid && whichPosition.touched }">
                  <label class="col-form-label col-form-label-sm">¿Cuál?</label>
                  <input type="text" class="form-control form-control-sm" [imask]="wordMask" [readonly]="position.value !== '32'" formControlName="whichPosition" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="whichPosition.errors && (whichPosition.dirty || whichPosition.touched)">
                    <span *ngIf="whichPosition.errors.required">Indique cuál</span>
                  </div>
                </div>
              </div>
              <!-- </div> -->
              <!-- Fila 2 -->
              <!-- <div class="row"> -->
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="business.value || job.value === '1' || job.value === '6'">
                <div class="form-group" [ngClass]="{ 'text-danger': contract.invalid && contract.touched }">
                  <label class="col-form-label col-form-label-sm">Tipo de contrato</label>
                  <ng-select
                    [items]="tc"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="contract"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="contract.errors && (contract.dirty || contract.touched)">
                    <span *ngIf="contract.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3" *ngIf="contract.value === '4'">
                <div class="form-group" [ngClass]="{ 'text-danger': whichContract.invalid && whichContract.touched }">
                  <label class="col-form-label col-form-label-sm">¿Cuál?</label>
                  <input type="text" class="form-control form-control-sm"  [imask]="wordMask" [readonly]="contract.value !== '4'" formControlName="whichContract" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="whichContract.errors && (whichContract.dirty || whichContract.touched)">
                    <span *ngIf="whichContract.errors.required">Indique cuál</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': chevyPlan.invalid && chevyPlan.touched }">
                  <label class="col-form-label col-form-label-sm">¿Tiene relación con ChevyPlan, GM, Concesionario?</label>
                  <ng-select
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="chevyPlan"
                    placeholder="Selecciona"
                    required
                    (blur)="saveForm(forma, formIdentifier)">
                    <ng-option value="Si">Si</ng-option>
                    <ng-option value="No">No</ng-option>
                  </ng-select>
                  <div *ngIf="chevyPlan.errors && (chevyPlan.dirty || chevyPlan.touched)">
                    <span *ngIf="chevyPlan.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <!-- <div class="form-group" [ngClass]="{ 'text-danger': address2.invalid && address2.touched }">
                  <label class="col-form-label col-form-label-sm">Dirección</label>
                  <input type="text" class="form-control form-control-sm" formControlName="address2">
                  <div *ngIf="address2.errors && (address2.dirty || address2.touched)">
                    <span *ngIf="address2.errors.required">Requerido</span>
                  </div>
                </div> -->
              </div>
              <!-- </div> -->
              <div class="col-sm-12 col-md-12 col-lg-12">
                <app-direccion
                  (direction)="addressConstructed($event)"
                  [editable]="true"
                  [address]="forma.controls.address2"
                  [id]="'address2'">
                </app-direccion>
              </div>
              <!-- Fila 3 -->
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': department2.invalid && department2.touched }">
                  <label class="col-form-label col-form-label-sm">Departamento</label>
                  <ng-select
                    (change)="c3 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="department2"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="department2.errors && (department2.dirty || department2.touched)">
                    <span *ngIf="department2.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': city2.invalid && city2.touched }">
                  <label class="col-form-label col-form-label-sm">Ciudad</label>
                  <ng-select
                    (change)="l3 = $event ? $event.localities : null"
                    [items]="c3"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!department2.value"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="city2"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="city2.errors && (city2.dirty || city2.touched)">
                    <span *ngIf="city2.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': location2.invalid && location2.touched }">
                  <label class="col-form-label col-form-label-sm">Localidad</label>
                  <ng-select
                    [items]="l3"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!city2.value || l3?.length === 0"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="location2"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="location2.errors && (location2.dirty || location2.touched)">
                    <span *ngIf="location2.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': phone2.invalid && phone2.touched }">
                  <label class="col-form-label col-form-label-sm">Teléfono</label>
                  <!-- <input #pmc type="text" class="form-control form-control-sm" id="phone-mask-change" placeholder="(###) ### #### o (###) ### ####" [imask]="otherMask" [unmask]="true" (input)="maskPhoneChange($event.target)" formControlName="phone2"> -->
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="phoneMask" [unmask]="true" formControlName="phone2" minlength="8" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="phone2.errors && (phone2.dirty || phone2.touched)">
                    <span *ngIf="phone2.errors.required">Requerido</span>
                    <span *ngIf="phone2.errors?.minlength">
                      El número de teléfono debe contener 10 dígitos
                    </span>
                  </div>
                </div>
              </div>
              <!-- </div> -->
              <!-- Fila 4 -->
              <!-- <div class="row"> -->
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': cellular2.invalid && cellular2.touched }">
                  <label class="col-form-label col-form-label-sm">Celular</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="cellularMask" [unmask]="true" formControlName="cellular2" minlength="10" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="cellular2.errors && (cellular2.dirty || cellular2.touched)">
                    <span *ngIf="cellular2.errors.required">Requerido</span>
                    <span *ngIf="cellular2.errors?.minlength">
                      El número de celular debe contener 10 dígitos
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 info">
                <!-- <div *ngIf="ciiu.value != null && job.value != null && business.value != null && chevyPlan.value != null
                  && contract.value != null && address2.value != null && department2.value != null
                  && city2.value != null && phone2.value != null && cellular2.value != null"
                  class="lb-success card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                </div>
                <div *ngIf="ciiu.value == null || job.value == null || business.value == null || chevyPlan.value == null
                  || contract.value == null || address2.value == null || department2.value == null
                  || city2.value == null || phone2.value == null || cellular2.value == null"
                  class="lb-success card-footer text-white" style="text-align: right;" class=" lb-process card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div> -->
                <div class="text-right lb-process card-footer text-white" *ngIf="(!ciiu.value || !job.value || (['1', '6'].includes(job?.value) && (!business.value || !position.value || !contract.value)) || (job?.value != '7' && !business.value) || (job?.value == '7' && !whichJob.value) || (position?.value == '32' && !whichPosition.value) || (contract?.value == '4' && !whichContract.value) || !chevyPlan.value || !address2.valid || !department2.value || !city2.value || !phone2.value); else sc_ae">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div>
                <ng-template #sc_ae>
                  <div class="text-right lb-success card-footer text-white">
                    <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloIndependiente" data-toggle="collapse" data-target="#infoIndependiente" aria-expanded="false" aria-controls="infoIndependiente" *ngIf="job.value === '2'">
            <h4 class="mb-0">Solo para independientes</h4>
          </div>
          <div id="infoIndependiente" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloIndependiente" *ngIf="job.value === '2'">
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-6">
                <div class="form-group" [ngClass]="{ 'text-danger': activities2.invalid && activities2.touched }">
                  <label class="col-form-label col-form-label-sm">Especifique su actividad</label>
                  <input type="text" class="form-control form-control-sm" formControlName="activities2" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="activities2.errors && (activities2.dirty || activities2.touched)">
                    <span *ngIf="activities2.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': composition.invalid && composition.touched }">
                  <label class="col-form-label col-form-label-sm">Composición</label>
                  <ng-select
                    [items]="c"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="composition"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="composition.errors && (composition.dirty || composition.touched)">
                    <span *ngIf="composition.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': sectorActivity.invalid && sectorActivity.touched }">
                  <label class="col-form-label col-form-label-sm">Sector actividad económica</label>
                  <ng-select
                    [items]="sa"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="sectorActivity"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="sectorActivity.errors && (sectorActivity.dirty || sectorActivity.touched)">
                    <span *ngIf="sectorActivity.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <!-- </div> -->
              <!-- Fila 2 -->
              <!-- <div class="row"> -->
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': chamberOfCommerce.invalid && chamberOfCommerce.touched }">
                  <label class="col-form-label col-form-label-sm">¿Registrado en la Cámara de Comercio?</label>
                  <ng-select
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="chamberOfCommerce"
                    placeholder="Selecciona"
                    (blur)="saveForm(forma, formIdentifier)">
                    <ng-option value="Si">Si</ng-option>
                    <ng-option value="No">No</ng-option>
                  </ng-select>
                  <div *ngIf="chamberOfCommerce.errors && (chamberOfCommerce.dirty || chamberOfCommerce.touched)">
                    <span *ngIf="chamberOfCommerce.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': employees.invalid && employees.touched }">
                  <label class="col-form-label col-form-label-sm">Número de empleados</label>
                  <ng-select
                    [items]="e"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="employees"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="employees.errors && (employees.dirty || employees.touched)">
                    <span *ngIf="employees.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': participation.invalid && participation.touched }">
                  <label class="col-form-label col-form-label-sm">Participación <sup><strong>1</strong></sup></label>
                  <div class="input-group input-group-sm mb-auto">
                    <input type="text" class="form-control form-control-sm text-right" [imask]="percentMask" [unmask]="'typed'" formControlName="participation" (blur)="saveForm(forma, formIdentifier)">
                    <div class="input-group-prepend">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div *ngIf="participation.errors && (participation.dirty || participation.touched)">
                    <span *ngIf="participation.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-12 info">
                <sup><strong>1</strong></sup><sub> % de participación en la empresa</sub>
                <!-- <div *ngIf="activities2.value != null && composition.value != null && sectorActivity.value != null && chamberOfCommerce.value != null
                  && employees.value != null && participation.value != null"
                  class="lb-success card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                </div>
                <div *ngIf="activities2.value == null || composition.value == null || sectorActivity.value == null || chamberOfCommerce.value == null
                || employees.value == null || participation.value == null"
                  class="lb-success card-footer text-white" style="text-align: right;" class=" lb-process card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div> -->
                <div class="text-right lb-process card-footer text-white" *ngIf="(!activities2.value || !composition.value || sectorActivity.value == null || chamberOfCommerce.value == null || employees.value == null); else sc_spi"
                  ><!--|| participation.value == null-->
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div>
                <ng-template #sc_spi>
                  <div class="text-right lb-success card-footer text-white">
                    <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloFinanciera" data-toggle="collapse" data-target="#infoFinanciera" aria-expanded="false" aria-controls="infoFinanciera">
            <h4 class="mb-0">Información y experiencia financiera</h4>
          </div>
          <div id="infoFinanciera" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloFinanciera">
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': monthlyIncome.invalid && monthlyIncome.touched }">
                  <label class="col-form-label col-form-label-sm">Ingresos mensuales <sup><strong>1</strong></sup></label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="true"
                      (change)="sumTotalIncome()" formControlName="monthlyIncome" (blur)="saveForm(forma, formIdentifier)" (blur)="saveForm(forma, formIdentifier)">
                    </span>
                  </div>
                  <div *ngIf="monthlyIncome.errors && (monthlyIncome.dirty || monthlyIncome.touched)">
                    <span *ngIf="monthlyIncome.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': otherIncome.invalid && otherIncome.touched }">
                  <label class="col-form-label col-form-label-sm">Otros ingresos mensuales </label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="true" (change)="sumTotalIncome()" formControlName="otherIncome" (blur)="saveForm(forma, formIdentifier)">
                    </span>
                  </div>
                  <!--<div *ngIf="otherIncome.errors && (otherIncome.dirty || otherIncome.touched)">
                    <span *ngIf="otherIncome.errors.required">Requerido</span>
                  </div>-->
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': descriptionOtherIncome.invalid && descriptionOtherIncome.touched }">
                  <label class="col-form-label col-form-label-sm">Descripción de otros ingresos</label>
                  <input type="text" class="form-control form-control-sm" [readonly]="!otherIncome.value || otherIncome.value == 0" formControlName="descriptionOtherIncome" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="descriptionOtherIncome.errors && (descriptionOtherIncome.dirty || descriptionOtherIncome.touched)">
                    <span *ngIf="descriptionOtherIncome.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': totalIncome.invalid && totalIncome.touched }">
                  <label class="col-form-label col-form-label-sm">Total ingresos</label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="true" readonly formControlName="totalIncome" (blur)="saveForm(forma, formIdentifier)">
                    </span>
                  </div>
                  <div *ngIf="totalIncome.errors && (totalIncome.dirty || totalIncome.touched)">
                    <span *ngIf="totalIncome.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 2 -->
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': totalExpenses.invalid && totalExpenses.touched }">
                  <label class="col-form-label col-form-label-sm">Total egresos mensuales</label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="true" formControlName="totalExpenses" (blur)="saveForm(forma, formIdentifier)">
                    </span>
                    </div>
                  <div *ngIf="totalExpenses.errors && (totalExpenses.dirty || totalExpenses.touched)">
                    <span *ngIf="totalExpenses.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': totalAssets.invalid && totalAssets.touched }">
                  <label class="col-form-label col-form-label-sm">Total activos</label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="true" formControlName="totalAssets" (blur)="saveForm(forma, formIdentifier)">
                    </span>
                  </div>
                  <div *ngIf="totalAssets.errors && (totalAssets.dirty || totalAssets.touched)">
                    <span *ngIf="totalAssets.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': assetsDetail.invalid && assetsDetail.touched }">
                  <label class="col-form-label col-form-label-sm" for="actives">Indique detalles de activos</label>
                  <ng-select
                    [items]="a"
                    [clearSearchOnAdd]="true"
                    [closeOnSelect]="false"
                    labelForId="state"
                    [multiple]="true"
                    placeholder="Selecciona"
                    [loading]="a.length === 0"
                    loadingText="Cargando, por favor espere..."
                    clearAllText="Limpiar"
                    formControlName="assetsDetail"
                    [bindValue]="'valueId'"
                    [bindLabel]="'name'"
                    [readonly]="!totalAssets.value"
                    class="custom-multi"
                    (blur)="saveForm(forma, formIdentifier)">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <div class="row" style="width: fit-content; margin-left: 0px">
                        <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}" style="margin-right: 10px"/>
                      {{item['name']}}
                    </div>
                    </ng-template>
                    <ng-template ng-multi-label-tmp let-items="items">
                      <div class="ng-value" *ngFor="let item of items">
                        {{item['name']}}
                      </div>
                    </ng-template>
                  </ng-select>
                  <div *ngIf="assetsDetail.errors && (assetsDetail.dirty || assetsDetail.touched)">
                    <span *ngIf="assetsDetail.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': totalPassive.invalid && totalPassive.touched }">
                  <label class="col-form-label col-form-label-sm">Total pasivos</label>
                  <div class="input-group input-group-sm mb-auto">
                    <span class="input-dollar">
                      <input type="text" class="form-control form-control-sm text-right" [imask]="currencyMask" [unmask]="true" formControlName="totalPassive" (blur)="saveForm(forma, formIdentifier)">
                    </span>
                    </div>
                  <div *ngIf="totalPassive.errors && (totalPassive.dirty || totalPassive.touched)">
                    <span *ngIf="totalPassive.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-12 info">
                <sup><strong>1</strong></sup><sub> Ingresos mensuales de la actividad principal</sub>
                <!-- <div *ngIf="monthlyIncome.value != null && totalExpenses.value != null && totalAssets.value != null && assetsDetail.value != null && totalPassive.value != null"
                  class="lb-success card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                </div>
                <div *ngIf="monthlyIncome.value == null || totalExpenses.value == null || totalAssets.value == null || assetsDetail.value == null || totalPassive.value == null"
                  class="lb-success card-footer text-white" style="text-align: right;" class=" lb-process card-footer text-white" style="text-align: right;">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div> -->
                <div class="text-right lb-process card-footer text-white" *ngIf="(!monthlyIncome.value || !totalExpenses.value || !totalAssets.value || ((otherIncome.value && otherIncome.value != 0) && !descriptionOtherIncome.value) || (totalAssets.value && assetsDetail.errors)); else sc_if">
                  <span><fa-icon class="text-white" [icon]="['fas', 'times']"></fa-icon> Información incompleta</span>
                </div>
                <ng-template #sc_if>
                  <div class="text-right lb-success card-footer text-white">
                    <span><fa-icon class="text-white" [icon]="['fas', 'check']"></fa-icon> Información completa</span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloReferencias" data-toggle="collapse" data-target="#infoReferencias" aria-expanded="false" aria-controls="infoReferencias">
            <h4 class="mb-0">Información referencias</h4>
          </div>
          <div id="infoReferencias" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloReferencias">
            <!-- Fila 1 -->
            <div class="row justify-content-center">
              <div class="col-sm-12 col-md-5 col-lg-3 border border-info rounded m-1 p-2">
                <div class="form-group" [ngClass]="{ 'text-danger': reference3.invalid && reference3.touched }">
                  <ng-select
                    [items]="r"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [readonly]="true"
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="reference3"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="reference3.errors && (reference3.dirty || reference3.touched)">
                    <span *ngIf="reference3.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': name3.invalid && name3.touched }">
                  <label class="col-form-label col-form-label-sm">Nombre</label>
                  <input type="text" class="form-control form-control-sm" formControlName="name3" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="name3.errors && (name3.dirty || name3.touched)">
                    <span *ngIf="name3.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': relation3.invalid && relation3.touched }">
                  <label class="col-form-label col-form-label-sm">Parentesco</label>
                  <ng-select
                    [items]="pa"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="relation3"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="relation3.errors && (relation3.dirty || relation3.touched)">
                    <span *ngIf="relation3.errors.required">Requerido</span>
                  </div>
                </div>
                <app-direccion (direction)="addressConstructed($event)"
                  [editable]="true"
                  [address]="forma.controls.address3"
                  [size]="true"
                  [id]="'address3'">
                </app-direccion>

                <!-- <div class="form-group" [ngClass]="{
                    'text-danger': address3.invalid && address3.touched }">
                  <label class="col-form-label col-form-label-sm">Dirección</label>
                  <input type="text" class="form-control form-control-sm" formControlName="address3">
                  <div *ngIf="address3.errors && (address3.dirty || address3.touched)">
                    <span *ngIf="address3.errors.required">Requerido</span>
                  </div>
                </div> -->
                <div class="form-group" [ngClass]="{ 'text-danger': (department3.invalid && department3.touched) || (city3.invalid && city3.touched) }">
                  <label class="col-form-label col-form-label-sm">Departamento/Ciudad</label>
                  <ng-select
                    (change)="c4 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom mb-1"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona un departamento"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="department3"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="department3.errors && (department3.dirty || department3.touched)">
                    <span *ngIf="department3.errors.required">Requerido</span>
                  </div>
                  <ng-select
                    [items]="c4"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!department3.value"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona una ciudad"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="city3"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="city3.errors && (city3.dirty || city3.touched)">
                    <span *ngIf="city3.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': phone3.invalid && phone3.touched }">
                  <label class="col-form-label col-form-label-sm">Teléfono</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="phoneMask" [unmask]="true" formControlName="phone3" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="phone3.errors && (phone3.dirty || phone3.touched)">
                    <span *ngIf="phone3.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': cellular3.invalid && cellular3.touched }">
                  <label class="col-form-label col-form-label-sm">Celular</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="cellularMask" [unmask]="true" formControlName="cellular3" minlength="10" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="cellular3.errors && (cellular3.dirty || cellular3.touched)">
                    <span *ngIf="cellular3.errors.required">Requerido</span>
                    <span *ngIf="cellular3.errors?.minlength">
                      El número de celular debe contener 10 dígitos
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-5 col-lg-3 border border-info rounded m-1 p-2">
                <div class="form-group" [ngClass]="{ 'text-danger': reference31.invalid && reference31.touched }">
                  <ng-select
                    [items]="r"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [readonly]="true"
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="reference31"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="reference31.errors && (reference31.dirty || reference31.touched)">
                    <span *ngIf="reference31.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': name31.invalid && name31.touched }">
                  <label class="col-form-label col-form-label-sm">Nombre</label>
                  <input type="text" class="form-control form-control-sm" formControlName="name31" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="name31.errors && (name31.dirty || name31.touched)">
                    <span *ngIf="name31.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': relation31.invalid && relation31.touched }">
                  <label class="col-form-label col-form-label-sm">Parentesco</label>
                  <ng-select
                    [items]="pa"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="relation31"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="relation31.errors && (relation31.dirty || relation31.touched)">
                    <span *ngIf="relation31.errors.required">Requerido</span>
                  </div>
                </div>
                <app-direccion (direction)="addressConstructed($event)"
                  [editable]="true"
                  [address]="forma.controls.address31"
                  [size]="true"
                  [id]="'address31'">
                </app-direccion>
                <!-- <div class="form-group" [ngClass]="{
                    'text-danger': address31.invalid && address31.touched }">
                  <label class="col-form-label col-form-label-sm">Dirección</label>
                  <input type="text" class="form-control form-control-sm" formControlName="address31">
                  <div *ngIf="address31.errors && (address31.dirty || address31.touched)">
                    <span *ngIf="address31.errors.required">Requerido</span>
                  </div>
                </div> -->
                <div class="form-group" [ngClass]="{ 'text-danger': (department31.invalid && department31.touched) || (city31.invalid && city31.touched) }">
                  <label class="col-form-label col-form-label-sm">Departamento/Ciudad</label>
                  <ng-select
                    (change)="c41 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom mb-1"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona un departamento"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="department31"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="department31.errors && (department31.dirty || department31.touched)">
                    <span *ngIf="department31.errors.required">Requerido</span>
                  </div>
                  <ng-select
                    [items]="c41"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!department31.value"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona una ciudad"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="city31"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="city31.errors && (city31.dirty || city31.touched)">
                    <span *ngIf="city31.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': phone31.invalid && phone31.touched }">
                  <label class="col-form-label col-form-label-sm">Teléfono</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="phoneMask" [unmask]="true" formControlName="phone31" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="phone31.errors && (phone31.dirty || phone31.touched)">
                    <span *ngIf="phone31.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': cellular31?.invalid && cellular31?.touched }">
                  <label class="col-form-label col-form-label-sm">Celular</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="cellularMask" [unmask]="true" formControlName="cellular31" minlength="10" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="cellular31.errors && (cellular31.dirty || cellular31.touched)">
                    <span *ngIf="cellular31.errors.required">Requerido</span>
                    <span *ngIf="cellular31.errors?.minlength">
                      El número de celular debe contener 10 dígitos
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-5 col-lg-3 border border-info rounded m-1 p-2" *ngIf="job.value === '2' || job.value === '3'">
                <div class="form-group" [ngClass]="{ 'text-danger': reference32.invalid && reference32.touched }">
                  <ng-select
                    [items]="r"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    [readonly]="true"
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="reference32"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="reference32.errors && (reference32.dirty || reference32.touched)">
                    <span *ngIf="reference32.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': name32.invalid && name32.touched }">
                  <label class="col-form-label col-form-label-sm">Nombre</label>
                  <input type="text" class="form-control form-control-sm" formControlName="name32" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="name32.errors && (name32.dirty || name32.touched)">
                    <span *ngIf="name32.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': relation32.invalid && relation32.touched }">
                  <label class="col-form-label col-form-label-sm">Parentesco</label>
                  <ng-select
                    [items]="pa"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="relation32"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="relation32.errors && (relation32.dirty || relation32.touched)">
                    <span *ngIf="relation32.errors.required">Requerido</span>
                  </div>
                </div>
                <app-direccion (direction)="addressConstructed($event)"
                  [editable]="true"
                  [address]="forma.controls.address32"
                  [size]="true"
                  [id]="'address32'">
                </app-direccion>
                <!-- <div class="form-group" [ngClass]="{
                    'text-danger': address32.invalid && address32.touched }">
                  <label class="col-form-label col-form-label-sm">Dirección</label>
                  <input type="text" class="form-control form-control-sm" formControlName="address32">
                  <div *ngIf="address32.errors && (address32.dirty || address32.touched)">
                    <span *ngIf="address32.errors.required">Requerido</span>
                  </div>
                </div> -->
                <div class="form-group" [ngClass]="{ 'text-danger': (department32.invalid && department32.touched) || (city32.invalid && city32.touched) }">
                  <label class="col-form-label col-form-label-sm">Departamento/Ciudad</label>
                  <ng-select
                    (change)="c42 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom mb-1"
                    [virtualScroll]="true"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona un departamento"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="department32"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="department32.errors && (department32.dirty || department32.touched)">
                    <span *ngIf="department32.errors.required">Requerido</span>
                  </div>
                  <ng-select
                    [items]="c42"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!department32.value"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona una ciudad"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="city32"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="city32.errors && (city32.dirty || city32.touched)">
                    <span *ngIf="city32.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': phone32.invalid && phone32.touched }">
                  <label class="col-form-label col-form-label-sm">Teléfono</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="phoneMask" [unmask]="true" formControlName="phone32" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="phone32.errors && (phone32.dirty || phone32.touched)">
                    <span *ngIf="phone32.errors.required">Requerido</span>
                  </div>
                </div>
                <div class="form-group" [ngClass]="{ 'text-danger': cellular32.invalid && cellular32.touched }">
                  <label class="col-form-label col-form-label-sm">Celular</label>
                  <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="cellularMask" [unmask]="true" formControlName="cellular32" minlength="10" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="cellular32.errors && (cellular32.dirty || cellular32.touched)">
                    <span *ngIf="cellular32.errors.required">Requerido</span>
                    <span *ngIf="cellular32.errors?.minlength">
                      El número de celular debe contener 10 dígitos
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloAutorizacion" data-toggle="collapse" data-target="#infoAutorizacion" aria-expanded="false" aria-controls="infoAutorizacion">
            <h4 class="mb-0">Solicitud y autorización débito automático</h4>
          </div>
          <div id="infoAutorizacion" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloAutorizacion">
            <!-- Fila 1 -->
            <div class="row justify-content-center">
              <div class="col-12 text-sm-center py-2">
                <strong>Información de la empresa recaudadora</strong>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-5 py-1">
                <input class="form-control text-sm-center" type="text" readonly value="CHEVYPLAN S.A. NIT. 830.001.133-7  Patrimonio Autonómo Fideicomiso ChevyPlan S.A.">
              </div>
              <div class="col-sm-12 col-md-12 col-lg-5 py-1">
                <input class="form-control text-sm-center" type="text" readonly value="Servicio a pagar cuota y demás rubros del contrato de autofinanciamiento">
              </div>
              <div class="col-sm-12 col-md-12 col-lg-2 py-1">
                <input class="form-control text-sm-center" type="text" readonly value="Código: 0.0.0.1">
              </div>
            </div>
            <!-- Fila 2 -->
            <div class="row justify-content-center my-3">
              <div class="col-sm-12 col-md-6 col-lg-3">
                <!--<div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="customSwitch2" formControlName="automaticDebit">
                  <label class="custom-control-label" for="customSwitch2">¿Te gustaria autorizar débito automático?</label>
                </div>-->
                <div class="form-group" [ngClass]="{ 'text-danger': automaticDebit.invalid && automaticDebit.touched }">
                  <label class="col-form-label col-form-label-sm">¿Te gustaría autorizar débito automático?</label>
                  <ng-select
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="true"
                    formControlName="automaticDebit"
                    (blur)="saveForm(forma, formIdentifier)">
                    <ng-option [value]="valueBolean[0]">Si</ng-option>
                    <ng-option [value]="valueBolean[1]">No</ng-option>
                  </ng-select>
                  <div *ngIf="automaticDebit.errors && (automaticDebit.dirty || automaticDebit.touched)">
                    <span *ngIf="automaticDebit.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-2" *ngIf="automaticDebit.value">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="customSwitch3"  formControlName="hasSecondHolder" (blur)="saveForm(forma, formIdentifier)">
                  <label class="custom-control-label" for="customSwitch3">¿Tiene segundo titular?</label>
                </div>
              </div>
            </div>
            <!-- Fila 3 -->
            <div class="row justify-content-center" *ngIf="automaticDebit.value">
              <div class="col-12 text-sm-center py-2">
                <strong>Información primer titutar de la cuenta</strong>
              </div>
              <div class="col-12 text-sm-center">
                <div class="alert alert-dark justify-content-center py-3" role="alert">
                  <!-- <a href="#infoSolicitante" target="_self">Ver "Información del solicitante"</a> -->
                  Ver "Información del solicitante"
                </div>
              </div>
            </div>
            <!-- Fila 4 -->
            <div class="row" *ngIf="automaticDebit.value">
              <div class="col-12 text-sm-center">
                <strong>Información financiera de la cuenta</strong>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': automaticDebit.invalid && automaticDebit.touched }">
                  <label class="col-form-label col-form-label-sm">¿Titular de la cuenta es la misma persona que figura como solicitante en este formato?</label>
                  <ng-select
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="true"
                    formControlName="sameHolder"
                    (blur)="saveForm(forma, formIdentifier)">
                    <ng-option [value]="valueBolean[0]">Si</ng-option>
                    <ng-option [value]="valueBolean[1]">No</ng-option>
                  </ng-select>
                  <div *ngIf="sameHolder.errors && (sameHolder.dirty || sameHolder.touched)">
                    <span *ngIf="sameHolder.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': bank.invalid && bank.touched }">
                  <label class="col-form-label col-form-label-sm">Entidad financiera</label>
                  <ng-select
                    [items]="ef"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="bank"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="bank.errors && (bank.dirty || bank.touched)">
                    <span *ngIf="bank.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': accountNumber.invalid && accountNumber.touched }">
                  <label class="col-form-label col-form-label-sm">No. de cuenta</label>
                  <!--<input type="text" class="form-control form-control-sm" formControlName="accountNumber">-->
                  <!--<input type="text" class="form-control form-control-sm" onkeypress="() => event.charCode >= 48 && event.charCode <= 57" formControlName="accountNumber">-->
                  <input type="text" class="form-control form-control-sm" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" formControlName="accountNumber" maxlength="50" (blur)="saveForm(forma, formIdentifier)">
                  <div *ngIf="accountNumber.errors && (accountNumber.dirty || accountNumber.touched)">
                    <span *ngIf="accountNumber.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': accountType.invalid && accountType.touched }">
                  <label class="col-form-label col-form-label-sm">Tipo de cuenta</label>
                  <ng-select
                    [items]="tcs"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="accountType"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="accountType.errors && (accountType.dirty || accountType.touched)">
                    <span *ngIf="accountType.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': department4.invalid && department4.touched }">
                  <label class="col-form-label col-form-label-sm">Departamento</label>
                  <ng-select
                    (change)="c5 = $event ? $event.cities : null"
                    [items]="d"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="department4"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="department4.errors && (department4.dirty || department4.touched)">
                    <span *ngIf="department4.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': city4.invalid && city4.touched }">
                  <label class="col-form-label col-form-label-sm">Ciudad</label>
                  <ng-select
                    (change)="l5 = $event ? $event.localities : null"
                    [items]="c5"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!department4.value"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="city4"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="city4.errors && (city4.dirty || city4.touched)">
                    <span *ngIf="city4.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': location4.invalid && location4.touched }">
                  <label class="col-form-label col-form-label-sm">Localidad</label>
                  <ng-select
                    [items]="l5"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [virtualScroll]="true"
                    [readonly]="!city4.value || l5?.length === 0"
                    [loading]="d?.length === 0"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    notFoundText="No hay coincidencias"
                    clearAllText="Limpiar todo"
                    formControlName="location4"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="location4.errors && (location4.dirty || location4.touched)">
                    <span *ngIf="location4.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-3">
                <div class="form-group" [ngClass]="{ 'text-danger': debitFrom.invalid && debitFrom.touched }">
                  <label class="col-form-label col-form-label-sm">Débito a partir del</label>
                  <ng-select
                    [items]="df"
                    bindValue="valueId"
                    bindLabel="name"
                    class="custom"
                    [loading]="loadValues"
                    loadingText="Cargando por favor espere..."
                    placeholder="Selecciona"
                    [clearable]="false"
                    [searchable]="false"
                    formControlName="debitFrom"
                    (blur)="saveForm(forma, formIdentifier)">
                  </ng-select>
                  <div *ngIf="debitFrom.errors && (debitFrom.dirty || debitFrom.touched)">
                    <span *ngIf="debitFrom.errors.required">Requerido</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="hasSecondHolder.value">
              <!-- Fila 5 -->
              <div class="row">
                <div class="col-12 text-sm-center">
                  <strong>Información segundo titutar de la cuenta</strong>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': name4.invalid && name4.touched }">
                    <label class="col-form-label col-form-label-sm">Nombre completo</label>
                    <input type="text" class="form-control form-control-sm" formControlName="name4" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                    <div *ngIf="name4.errors && (name4.dirty || name4.touched)">
                      <span *ngIf="name4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': lastName4.invalid && lastName4.touched }">
                    <label class="col-form-label col-form-label-sm">Primer apellido</label>
                    <input type="text" class="form-control form-control-sm" formControlName="lastName4" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                    <div *ngIf="lastName4.errors && (lastName4.dirty || lastName4.touched)">
                      <span *ngIf="lastName4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': sureName4.invalid && sureName4.touched }">
                    <label class="col-form-label col-form-label-sm">Segundo apellido</label>
                    <input type="text" class="form-control form-control-sm" formControlName="sureName4" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                    <div *ngIf="sureName4.errors && (sureName4.dirty || sureName4.touched)">
                      <span *ngIf="sureName4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': documentNumber4.invalid && documentNumber4.touched }">
                    <label class="col-form-label col-form-label-sm">No. identificación</label>
                    <div class="input-group">
                      <ng-select
                        [items]="td"
                        bindValue="valueId"
                        bindLabel="valueId"
                        class="custom"
                        [loading]="loadValues"
                        loadingText="Cargando por favor espere..."
                        [clearable]="false"
                        [searchable]="false"
                        formControlName="typeOfIdentity4"
                        (blur)="saveForm(forma, formIdentifier)">
                      </ng-select>
                      <input type="text" class="form-control form-control-sm" formControlName="documentNumber4" [imask]="onlyNumberMask">
                    </div>
                    <div *ngIf="documentNumber4.errors && (documentNumber4.dirty || documentNumber4.touched)">
                      <span *ngIf="documentNumber4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Fila 6 -->
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': expeditionDate4.invalid && expeditionDate4.touched }">
                    <label class="col-form-label col-form-label-sm text-center">Fecha de expedición</label>
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm text-center" ngbDatepicker #d5="ngbDatepicker"
                      (click)="d5.toggle()" placeholder="Día/Mes/Año" [minDate]="minDate" [maxDate]="hoy" readonly formControlName="expeditionDate4" (blur)="saveForm(forma, formIdentifier)">
                      <button class="btn btn-info btn-sm" (click)="d5.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                    </div>
                    <div *ngIf="expeditionDate4.errors && (expeditionDate4.dirty || expeditionDate4.touched)">
                      <span *ngIf="expeditionDate4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': expeditionDepartment4.invalid && expeditionDepartment4.touched }">
                    <label class="col-form-label col-form-label-sm">Departamento de expedición</label>
                    <ng-select
                      (change)="c40 = $event ? $event.cities : null"
                      [items]="d"
                      bindValue="valueId"
                      bindLabel="name"
                      class="custom"
                      [virtualScroll]="true"
                      [loading]="loadValues"
                      loadingText="Cargando por favor espere..."
                      placeholder="Selecciona"
                      notFoundText="No hay coincidencias"
                      clearAllText="Limpiar todo"
                      formControlName="expeditionDepartment4"
                      (blur)="saveForm(forma, formIdentifier)">
                    </ng-select>
                    <div *ngIf="expeditionDepartment4.errors && (expeditionDepartment4.dirty || expeditionDepartment4.touched)">
                      <span *ngIf="expeditionDepartment4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': expeditionCity4.invalid && expeditionCity4.touched }">
                    <label class="col-form-label col-form-label-sm">Ciudad de expedición</label>
                    <ng-select
                      [items]="c40"
                      bindValue="valueId"
                      bindLabel="name"
                      class="custom"
                      [virtualScroll]="true"
                      [readonly]="!expeditionDepartment4.value"
                      [loading]="loadValues"
                      loadingText="Cargando por favor espere..."
                      placeholder="Selecciona"
                      notFoundText="No hay coincidencias"
                      clearAllText="Limpiar todo"
                      formControlName="expeditionCity4"
                      (blur)="saveForm(forma, formIdentifier)">
                    </ng-select>
                    <div *ngIf="expeditionCity4.errors && (expeditionCity4.dirty || expeditionCity4.touched)">
                      <span *ngIf="expeditionCity4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': sex4.invalid && sex4.touched }">
                    <label class="col-form-label col-form-label-sm">Género</label>
                    <ng-select
                      [items]="s"
                      bindValue="valueId"
                      bindLabel="name"
                      class="custom"
                      [loading]="loadValues"
                      loadingText="Cargando por favor espere..."
                      [clearable]="false"
                      [searchable]="false"
                      formControlName="sex4"
                      placeholder="Selecciona"
                      (blur)="saveForm(forma, formIdentifier)">
                    </ng-select>
                    <div *ngIf="sex4.errors && (sex4.dirty || sex4.touched)">
                      <span *ngIf="sex4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Fila 7 -->
              <app-direccion (direction)="addressConstructed($event)"
                  [editable]="true"
                  [address]="forma.controls.address4"
                  [id]="'address4'">
              </app-direccion>
              <div class="row">
                <!-- <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': address4.invalid && address4.touched }">
                    <label class="col-form-label col-form-label-sm">Dirección</label>
                    <input type="text" class="form-control form-control-sm" formControlName="address4">
                    <div *ngIf="address4.errors && (address4.dirty || address4.touched)">
                      <span *ngIf="address4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div> -->
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': phone4.invalid && phone4.touched }">
                    <label class="col-form-label col-form-label-sm">Teléfono</label>
                    <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="phoneMask" [unmask]="true" formControlName="phone4" (blur)="saveForm(forma, formIdentifier)">
                    <div *ngIf="phone4.errors && (phone4.dirty || phone4.touched)">
                      <span *ngIf="phone4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': cellular4.invalid && cellular4.touched }">
                    <label class="col-form-label col-form-label-sm">Celular</label>
                    <input type="text" class="form-control form-control-sm" placeholder="(###) ### ####" [imask]="cellularMask" [unmask]="true" formControlName="cellular4" (blur)="saveForm(forma, formIdentifier)">
                    <div *ngIf="cellular4.errors && (cellular4.dirty || cellular4.touched)">
                      <span *ngIf="cellular4.errors.required">Requerido</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                  <div class="form-group" [ngClass]="{ 'text-danger': email4.invalid && email4.touched }">
                    <label class="col-form-label col-form-label-sm">Correo electrónico</label>
                    <input type="text" class="form-control form-control-sm" [pattern]="emailPattern" onkeypress="return event.charCode != 32" formControlName="email4" (blur)="saveForm(forma, formIdentifier)">
                    <div *ngIf="email4.errors && (email4.dirty || email4.touched)">
                      <span *ngIf="email4.errors.required">Requerido</span>
                      <span *ngIf="email4.errors.pattern || email.errors.email">Formato email incorrecto</span>
                      <!-- <span *ngIf="email4.errors.existEmail">El email ya esta en uso</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 8 -->
            <div class="row justify-content-center">
              <div class="col-12 text-sm-center">
                <div class="alert alert-dark justify-content-center py-3" role="alert">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="switchInfoDebito" data-toggle="collapse" href="#textoInfoDebito" aria-expanded="false" aria-controls="textoInfoDebito">
                    <label class="custom-control-label" for="switchInfoDebito">Ver información relacionada con el servicio de débito automático</label>
                  </div>
                  <div class="collapse" id="textoInfoDebito">
                    <div class="card card-body text-justify">
                      En mi calidad de titular de LA CUENTA, otorgo a la Entidad Financiera, un mandato sin representación para recibir transacciones débito enviadas por Chevyplan® S.A., debitando mi cuenta aquí identificada, de acuerdo con la información aquí contenida, entendidas como aquellas transacciones Débito realizadas a través del sistema ACH mediante la cual Chevyplan® S.A. ordena a su Entidad Financiera Originadora (EFO) generar una transacción hacia la Entidad Financiera informada con el objeto de que ésta debite de LA CUENTA el valor correspondiente a pagar por el contrato de Autofinanciamiento Comercial anteriormente mencionado, para acreditar la cuenta de Chevyplan® S.A. y de ésta manera efectuar el pago correspondiente del servicio arriba relacionado. De acuerdo con lo anterior, manifiesto que conozco y acepto a entera satisfacción el reglamento para el servicio de Débito Automático.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloDebito" data-toggle="collapse" data-target="#infoDebito" aria-expanded="false" aria-controls="infoDebito">
            <h4 class="mb-0">Reglamento autorización débito automático</h4>
          </div>
          <div id="infoDebito" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloDebito">
            <!-- Fila 1 -->
            <div class="row">
              <div class="col-12 text-sm-center">
                <div class="alert alert-dark justify-content-center py-3" role="alert">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="switchReglamento" data-toggle="collapse" href="#textoReglamento" aria-expanded="false" aria-controls="textoReglamento">
                    <label class="custom-control-label" for="switchReglamento">Ver reglamento</label>
                  </div>
                  <div class="collapse" id="textoReglamento">
                    <div class="card card-body text-justify">
                      En mi condición de titular de la cuenta indicada, acepto incondicionalmente y durante la duración del contrato o mientras exista alguna obligación legal vigente con ChevyPlan® S.A. Sociedad Administradora de Planes de Autofinanciamiento Comercial, los siguientes términos y condiciones:<br>
                      1. Declaro que los datos contenidos en mi autorización son ciertos y correctos, por lo tanto, responderé por los perjuicios que pudieran derivarse por la inexactitud o falsedad en la información suministrada.<br>
                      2. Declaro que soy el titular de la cuenta y tengo las facultades necesarias para realizar la presente autorización, en su defecto asumiré las consecuencias que se deriven de no declarar la condición de manejo de firmas conjuntas de la cuenta, liberando así a ChevyPlan® S.A. y a la Entidad Financiera de toda responsabilidad.<br>
                      3. Autorizo realizar una operación de prenotificacion, entendida como una transacción no monetaria cuyo propósito es obtener una validación acerca de la existencia y condiciones de la cuenta según lo que decida ChevyPlan® S.A.<br>
                      4. Autorizo a debitar de la cuenta el valor a pagar del contrato de autofinanciamiento comercial de ChevyPlan® S.A., durante la vigencia del mismo, a partir del primer día hábil del mes, siempre que la cuenta tenga los fondos necesarios. No obstante, si en esa oportunidad no hay fondos disponibles en la cuenta o estos son insuficientes, el débito podrá hacerse cuando existan fondos disponibles, si mi calidad es la de deudor. Si me encuentro como suscriptor no deudor, el débito se podrá efectuar desde el primer día hábil del mes hasta el día del vencimiento a menos que se autorice algo distinto.<br>
                      5. Me comprometo a mantener los fondos suficientes en la cuenta todos los días del mes para cubrir las transacciones débito autorizadas.<br>
                      6. Si deseo(amos) autorizar a otra entidad financiera, a otro número o tipo de cuenta, entiendo y acepto que debo(emos) reemplazar la autorización vigente y realizar una nueva oportunamente, bajo los parámetros y condiciones establecidos por ChevyPlan® S.A.<br>
                      7. Que la presente autorización solamente podrá ser cancelada por el titular de la misma, mediante comunicación escrita, radicada y recibida por ChevyPlan® S.A. y se hará efectiva dentro de los diez (10) días hábiles siguientes.<br>
                      8. En caso de realizar una Cesión de derechos del plan y no continuar con el Débito Automático, me comprometo a realizar la cancelación del servicio teniendo en cuenta lo establecido en el numeral anterior.<br>
                      9. Que debo(emos) dirigir la reclamaciones o solicitudes de devolución del débito realizado, en un plazo máximo de cinco (5) días calendario a partir de la fecha de aplicación del débito, las cuales quedan sujetas a verificación de participación en asamblea en caso de ser suscriptor y en caso de ser ganador, siempre y cuando el plan se encuentre al día.<br>
                      10. La presente autorización tiene vigencia mientras el titular no comunique lo contrario o podrá ser cancelada cuando el débito sea rechazado por la entidad bancaria durante doce (12) meses consecutivos.<br>
                      11. ChevyPlan® S.A. podrá cancelar, limitar o adicionar los términos y condiciones de este reglamento, mediante previo aviso a través de la página web y/u otro medio y/o canal, de acuerdo con la ley, sin perjuicio de que se mantengan las calidades del servicio y siempre y cuando dichas modificaciones se justifiquen desde el punto de vista jurídico, técnico o comercial. Las modificaciones efectuadas se darán a conocer a los interesados en el portal de internet de ChevyPlan® S.A. Si enunciada la modificación el cliente no manifiesta por escrito la decisión de cancelar el servicio dentro de los treinta (30) días siguientes al aviso realizado por la Compañía, se entenderá que aceptará incondicionalmente las modificaciones introducidas.<br>
                      PROTECCIÓN DE DATOS: con la presente autorización, el titular de los datos personales entiende, acepta y autoriza que toda la información personal incluida por él, puede ser tratada por ChevyPlan® S.A. de conformidad con su Política de Tratamiento de Datos Personales publicada en la página web www.chevyplan.com.co que es de libre consulta.<br>
                      ChevyPlan® S.A. está comprometida, con el respeto y garantía de los derechos de los titulares de la información personal.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloPeps" data-toggle="collapse" data-target="#infoPeps" aria-expanded="false" aria-controls="infoPeps">
            <h4 class="mb-0">PEPS: Personas Expuestas Pública o Políticamente</h4>
          </div>
          <div id="infoPeps" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloPeps">
            <!-- Fila 1 -->
            <div class="form-group row justify-content-center">
              <div class="col-sm-12 col-md-6 col-lg-4 text-md-right">
                ¿Maneja o manejó recursos públicos?
              </div>
              <div class="col-sm-12 col-md-6 col-lg-auto">
                <ng-select
                  (change)="peps1.value === 'Si' ? requiredField(pepsDesc1) : resetField(pepsDesc1)"
                  class="custom peps-select"
                  [loading]="loadValues"
                  loadingText="Cargando por favor espere..."
                  [clearable]="false"
                  [searchable]="false"
                  formControlName="peps1"
                  placeholder="Selecciona"
                  (blur)="saveForm(forma, formIdentifier)">
                  <ng-option value="Si">Si</ng-option>
                  <ng-option value="No">No</ng-option>
                </ng-select>
                <div *ngIf="peps1.errors && (peps1.dirty || peps1.touched)">
                  <span *ngIf="peps1.errors.required" class="text-danger">Requerido</span>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-1 text-md-right">Explique</div>
              <div class="col-sm-12 col-md-6 col-lg-4" [ngClass]="{ 'text-danger': pepsDesc1.invalid && pepsDesc1.touched }">
                <textarea class="form-control form-control-sm" placeholder="" [readonly]="peps1.value !== 'Si'" formControlName="pepsDesc1" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)"></textarea>
                <div *ngIf="pepsDesc1.errors && (pepsDesc1.dirty || pepsDesc1.touched)">
                  <span *ngIf="pepsDesc1.errors.required">Requerido</span>
                </div>
              </div>
            </div>
            <!-- Fila 2 -->
            <div class="form-group row justify-content-center">
              <div class="col-sm-12 col-md-6 col-lg-4 text-md-right">
                ¿Desempeña o ha desempeñado algún cargo público?
              </div>
              <div class="col-sm-12 col-md-6 col-lg-auto">
                <ng-select
                  (change)="peps2.value === 'Si' ? requiredField(pepsDesc2) : resetField(pepsDesc2)"
                  class="custom peps-select"
                  [loading]="loadValues"
                  loadingText="Cargando por favor espere..."
                  [clearable]="false"
                  [searchable]="false"
                  formControlName="peps2"
                  placeholder="Selecciona"
                  (blur)="saveForm(forma, formIdentifier)">
                  <ng-option value="Si">Si</ng-option>
                  <ng-option value="No">No</ng-option>
                </ng-select>
                <div *ngIf="peps2.errors && (peps2.dirty || peps2.touched)">
                  <span *ngIf="peps2.errors.required" class="text-danger">Requerido</span>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-1 text-md-right">Cuál</div>
              <div class="col-sm-12 col-md-6 col-lg-4" [ngClass]="{ 'text-danger': pepsDesc2.invalid && pepsDesc2.touched }">
                <textarea class="form-control form-control-sm" placeholder="" [readonly]="peps2.value !== 'Si'" formControlName="pepsDesc2" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)"></textarea>
                <div *ngIf="pepsDesc2.errors && (pepsDesc2.dirty || pepsDesc2.touched)">
                  <span *ngIf="pepsDesc2.errors.required">Requerido</span>
                </div>
              </div>
            </div>
            <!-- Fila 3 -->
            <div class="form-group row justify-content-center">
              <div class="col-sm-12 col-md-6 col-lg-4 text-md-right">
                ¿Goza o gozó de reconocimiento público?
              </div>
              <div class="col-sm-12 col-md-6 col-lg-auto">
                <ng-select
                  (change)="peps3.value === 'Si' ? requiredField(pepsDesc3) : resetField(pepsDesc3)"
                  class="custom peps-select"
                  [loading]="loadValues"
                  loadingText="Cargando por favor espere..."
                  [clearable]="false"
                  [searchable]="false"
                  formControlName="peps3"
                  placeholder="Selecciona"
                  (blur)="saveForm(forma, formIdentifier)">
                  <ng-option value="Si">Si</ng-option>
                  <ng-option value="No">No</ng-option>
                </ng-select>
                <div *ngIf="peps3.errors && (peps3.dirty || peps3.touched)">
                  <span *ngIf="peps3.errors.required" class="text-danger">Requerido</span>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-1 text-md-right">Indique</div>
              <div class="col-sm-12 col-md-6 col-lg-4" [ngClass]="{ 'text-danger': pepsDesc3.invalid && pepsDesc3.touched }">
                <textarea class="form-control form-control-sm" placeholder="" [readonly]="peps3.value !== 'Si'" formControlName="pepsDesc3" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)"></textarea>
                <div *ngIf="pepsDesc3.errors && (pepsDesc3.dirty || pepsDesc3.touched)">
                  <span *ngIf="pepsDesc3.errors.required">Requerido</span>
                </div>
              </div>
            </div>
            <!-- Fila 4 -->
            <div class="form-group row justify-content-center">
              <div class="col-sm-12 col-md-6 col-lg-4 text-md-right">
                ¿Existe algún vínculo de consanguineidad entre usted y algún funcionario público?
              </div>
              <div class="col-sm-12 col-md-6 col-lg-auto">
                <ng-select
                  (change)="peps4.value === 'Si' ? requiredField(pepsDesc4) : resetField(pepsDesc4)"
                  class="custom peps-select"
                  [loading]="loadValues"
                  loadingText="Cargando por favor espere..."
                  [clearable]="false"
                  [searchable]="false"
                  formControlName="peps4"
                  placeholder="Selecciona"
                  (blur)="saveForm(forma, formIdentifier)">
                  <ng-option value="Si">Si</ng-option>
                  <ng-option value="No">No</ng-option>
                </ng-select>
                <div *ngIf="peps4.errors && (peps4.dirty || peps4.touched)">
                  <span *ngIf="peps4.errors.required" class="text-danger">Requerido</span>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-1 text-md-right">Indique</div>
              <div class="col-sm-12 col-md-6 col-lg-4" [ngClass]="{ 'text-danger': pepsDesc4.invalid && pepsDesc4.touched }">
                <textarea class="form-control form-control-sm mt-2" placeholder="" [readonly]="peps4.value !== 'Si'" formControlName="pepsDesc4" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)"></textarea>
                <div *ngIf="pepsDesc4.errors && (pepsDesc4.dirty || pepsDesc4.touched)">
                  <span *ngIf="pepsDesc4.errors.required">Requerido</span>
                </div>
              </div>
            </div>
            <!-- Fila 5 -->
            <div class="form-group row justify-content-center">
              <div class="col-sm-12 col-md-6 col-lg-2 text-md-right"><br>Fuente de ingresos</div>
              <div class="col-sm-12 col-md-6 col-lg-5" [ngClass]="{ 'text-danger': sourceOfIncome.invalid && sourceOfIncome.touched }">
                <input class="form-control form-control-sm mt-2" formControlName="sourceOfIncome" [imask]="nameMask" (blur)="saveForm(forma, formIdentifier)">
                <div *ngIf="sourceOfIncome.errors && (sourceOfIncome.dirty || sourceOfIncome.touched)">
                  <span *ngIf="sourceOfIncome.errors.required">Requerido</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-header" role="tab" id="tituloDeclaraciones" data-toggle="collapse" data-target="#infoDeclaraciones" aria-expanded="false" aria-controls="infoDeclaraciones">
            <h4 class="mb-0">Autorizaciones y declaraciones</h4>
          </div>
          <div id="infoDeclaraciones" class="card-body collapse show" role="tabpanel" aria-labelledby="tituloDeclaraciones">
            <!-- Fila 1 -->
            <div class="row justify-content-center">
              <div class="col-12 text-sm-center">
                <div class="alert alert-dark justify-content-center py-3" role="alert">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="switchAutorizaciones" data-toggle="collapse" href="#textoAutorizaciones" aria-expanded="false" aria-controls="textoAutorizaciones">
                    <label class="custom-control-label" for="switchAutorizaciones">Ver información</label>
                  </div>
                  <div class="col-12 collapse" id="textoAutorizaciones">
                    <div class="card card-body text-justify">
                      <span class="text-uppercase font-weight-bold">EN CUANTO A SAGRLAFT SISTEMA DE AUTOCONTROL Y GESTIÓN DEL RIESGO DE LAVADO DE ACTIVOS Y FINANCIACIÓN DEL TERRORISMO.</span>
                      <span class="font-weight-bold text-decoration-underline">Declaración de Origen de Fondos:</span>
                      i. Declaro que NO me encuentro en ninguna lista de las establecidas a nivel nacional o internacional para el control de activos y financiación del terrorismo. En caso de celebrar el contrato de autofinanciamiento comercial en calidad de persona Jurídica el suscriptor, suscriptor adjudicado y/o ganador se responsabiliza porque sus empleados, accionistas, miembros de junta directiva o de socios, sus representantes legales y su revisor fiscal no se encuentran en dichas listas.<br>
                      ii. Declaro que indemnizaré y mantendré libre de cualquier daño a ChevyPlan® por cualquier multa o perjuicio que fueran probados y que sufra ChevyPlan® por o con ocasión del incumplimiento de mi parte de las obligaciones que le apliquen en materia de prevención del riesgo de lavado de activos y financiación del terrorismo, así como cualquier reclamo judicial, extrajudicial y/o administrativo que autoridades competentes inicien en contra de ChevyPlan® por o con ocasión de dicho incumplimiento. Igualmente, me comprometo a dar las explicaciones a que hubiere lugar originadas por el mencionado incumplimiento a ChevyPlan® y a terceros que este le indique.<br>
                      iii. Declaro que los datos suministrados en la Aceptación de adhesión al sistema de autofinanciamiento y en el presente documento son verídicos, correctos y acordes con mi realidad económica, financiera y tributaria actual, los cuales soportan el pago de las cuotas con ChevyPlan®.<br>
                      iv. Me obligo con ChevyPlan® a: Actualizar la información aquí consignada como mínimo una vez al año, o cuando esta cambie y a suministrar los documentos exigidos por la ley en el momento en que estos sean solicitados para el control del lavado de activos y financiación del terrorismo.<br>
                      v. Destinaré los fondos que procedan de cualquier devolución o adjudicación que me otorgue ChevyPlan® para los fines específicos para los que hayan sido concedidos y en ningún caso para la realización de actividades ilícitas.<br>
                      vi. No admitiré que terceros efectúen depósitos en mi Plan de Autofinanciamiento o cancelen obligaciones a mi nombre, para con ChevyPlan®, con fondos provenientes de actividades ilícitas o aparentemente ilícitas, ni efectuaré transacciones destinadas a tales actividades o a favor de personas aparentemente o efectivamente relacionadas con las mismas.<br>
                      vii. MANIFIESTO QUE LOS RECURSOS QUE ENTREGO Y ENTREGARÉ PARA PAGAR CUOTAS DEL CONTRATO DE AUTOFINANCIAMIENTO COMERCIAL A MI NOMBRE O EL DE MI REPRESENTADA TIENEN UN ORIGEN LÍCITO, NO SON PRODUCTO DE ACTIVIDAD(ES) ILÍCITA(S) Y PROVIENEN DE LAS SIGUIENTES FUENTES (Detalle de la ocupación, oficio, profesión, negocio):<br><br><br><br>
                      <span class="text-center"><hr width="60%"></span>
                      Declaro que conozco y entiendo  que para la evaluación de mi  capacidad de pago sólo se tendrán en cuenta los ingresos presentados y soportados en Colombia.<br><br>
                      <span class="font-weight-bold text-decoration-underline">EN CUANTO A LOS DEMÁS DEUDORES Y/O CODEUDORES DE LA OBLIGACIÓN:</span>
                      Me obligo igualmente a informar a ChevyPlan® S.A. por escrito cualquier novedad ocurrida en relación con el deudor (es) conjuntos y mi (s) codeudor (es) tales como enfermedad grave o fallecimiento de éste (estos), a más tardar dentro de los diez días hábiles siguientes a la ocurrencia del hecho. En caso de no proceder en este sentido, o dentro del término establecido, me obligo a asumir cualquier daño, perjuicio o costa, en que incurra o sea condenada la sociedad ChevyPlan® S.A., en cualquier clase de trámite o proceso administrativo o judicial, como consecuencia de la declaratoria de una nulidad por no haberse interrumpido el proceso por el acaecimiento de dicha circunstancia.<br><br>
                      <span class="font-weight-bold text-decoration-underline">EN CUANTO A MI INFORMACIÓN PERSONAL, COMERCIAL Y LABORAL</span>
                      1. En la medida que se desprende de la relación contractual que sostendremos,  declaro que la información que he suministrado es verídica y doy mi consetimiento expreso e irrevocable a ChevyPlan® o a quien ésta designe,  para: (i) Consultar en cualquier tiempo, en Data Crédito (Experian) y/o CIFIN (TransUnión)  o en cualquier otra central de información de riesgo, bancos de datos o las listas emitidas por las diferentes entidades privadas y/o gubernamentales, nacionales o extranjeras que ChevyPlan® considere necesario, para conocer y validar toda la información relevante a mi desempeño como deudor, mi capacidad de pago o para valorar el riesgo futuro de concederme un crédito, el origen de mis ingresos, mis antecedentes penales, disciplinarios, entre otros. (ii) Reportar a Data Crédito (Experian) y/o CIFIN (TransUnión) o cualquier otra central de información de riesgo datos, tratados o sin tratar, tanto sobre el cumplimiento oportuno como sobre el incumplimiento, si lo hubiere, de mis obligaciones, o de mis deberes legales de contenido patrimonial, de tal forma que éstas presenten una información veraz, pertinente, completa, actualizada y exacta de mi desempeño como deudor después de haber cruzado y procesado diversos datos útiles para obtener información significativa. (iii) Suministrar a Data Crédito (Experian) y/o CIFIN (TransUnión) o cualquier otra central de información de riesgo datos relativos a mis solicitudes de crédito, así como otros atinentes a mis relaciones comerciales, financieras y en general socioeconómicas que haya(amos) entregado o que consten en registros públicos, bases de datos públicas o documentos públicos. (iv) Verificar y constatar a través de mis referencias personales, comerciales y laborales la información que he suministrado y se deje constancia fotográfica cuando se requiera. (v) Revelar mi información personal y de los negocios, en caso de que se requiera por una autoridad competente en Colombia como la UIAF, la Fiscalía General de la Nación, o la entidad competente.<br>
                      2. Autorizo a ChevyPlan® o a quien ésta designe para que por medio de comunicaciones físicas o electrónicas, mensajes de texto o de voz, telefónica o personalmente me i. Informe sobre el resultado de la adjudicación, cambios de plan, bien, porcentaje o Cesiones, el estudio de mi capacidad de pago, la entrega de mi vehículo, sobre el estado de mi Plan u obligación, extracto y/o factura y en general información relacionada con los productos y servicios de la Compañía.  ii. Remita información y publicidad sobre los Planes de Autofinanciamiento Comercial.  iii. Contacte de forma personal, telefónica o escrita para actualizar mi información personal, recibir información sobre mi Plan y obligación(es).  iv. Cuando ChevyPlan® desembolse el valor adjudicado me informe acerca del estado de mi obligación y el reporte que realizará ante las centrales de información de riesgo y efectúe gestiones de cobro preventivo, persuasivo, pre jurídico o jurídico de la obligación que adquirí con ChevyPlan®.  En consecuencia, cualquier cambio o cancelación de la dirección del correo física y/o electrónica o los números telefónicos además de ser informados de inmediato a ChevyPlan® por escrito, lo haré por cualquier otro medio. Así mismo, autorizo para que los mensajes remitidos por cualquiera de los medios anteriormente descritos sirvan de prueba ante mí, ante cualquier entidad Gubernamental, Administrativa o Judicial, así como en respuestas a peticiones, quejas o reclamos. v. me contacten para ofrecerme una nueva vinculación al sistema de autofinanciamiento comercial.  En consecuencia, entiendo y acepto que la eventual aceptación frente a una nueva vinculación se surta por medio telefónico. Así mismo, autorizo para que los mensajes remitidos por cualquiera de los medios anteriormente descritos sirvan de prueba ante mí, ante cualquier entidad Gubernamental, Administrativa o Judicial, así como en respuestas a peticiones, quejas o reclamos. Igualmente, autorizo a ChevyPlan® para que los extractos y/o facturas sean remitidos únicamente al primer titular que figura en la Aceptación de adhesión al sistema de autofinanciamiento.<br>
                      3. Autorizo a ChevyPlan® o a quien ésta designe para que: i. Me entreviste sobre mi experiencia en el sistema de autofinanciamiento que administra ChevyPlan® y ii. Me tome fotografías y publique las mismas con ocasión de mi vinculación como cliente de ChevyPlan®. iii.  Publique en diferentes medios de comunicación el resultado de las adjudicaciones, indicando datos relacionados con mi Plan y el tipo de adjudicación en caso de resultar favorecido.<br>
                      4. De manera libre, voluntaria y expresa autorizo a ChevyPlan® y a las personas jurídicas con las cuales ChevyPlan® mantenga una relación comercial o contractual de cualquier naturaleza, para que lleven a cabo el tratamiento de mis datos personales; en consecuencia, podrán recolectar, almacenar, usar, circular, transferir, trasmitir, suprimir y/o actualizar mis datos e información personal. En ese sentido, el tratamiento por la presente autorización permite a ChevyPlan®, a las personas jurídicas con las cuales éste mantenga una relación comercial o contractual de cualquier naturaleza, las finalidades legítimas de: i) realizar gestiones comerciales; ii) ofrecerme productos o servicios, propios o de terceros; iii) informar sobre campañas y estrategias promocionales y de mercadeo; iv) recibir información, ofertas comerciales y publicitarias de productos de ChevyPlan® y de aliados de éste; v) recibir cualquier tipo de información y/o comunicación que ChevyPlan® estime necesaria.<br>
                      5. Autorizo a ChevyPlan® o a quien ésta designe para que organice, custodie, almacene y utilice mí información personal y la documentación por mi entregada para llevar un control sobre la información de sus clientes, para los fines establecidos en los numerales 1 a 4 del acápite AUTORIZACIONES del presente documento y para el almacenamiento y/o archivo de mi información.<br>
                      6. En mi eventual calidad de deudor y titular del derecho de dominio sobre el bien que recibiré como producto de la adjudicación en el sistema de autofinanciamiento comercial, autorizo a ChevyPlan® a realizar directamente o a través de un tercero los trámites de registro en especial de la prenda y/o gravamen judicial sobre el bien automotor dado en garantía, así como su modificación o cancelación ante la autoridad de tránsito y Confecámaras o las entidades que hagan sus veces. Igualmente, desde ahora declaro que serán de mi cargo todos los gastos que ocasionen los conceptos anteriormente descritos, en consecuencia desde ahora autorizo a ChevyPlan® S.A. a cargarlos como gasto o costa a la obligación garantizada mediante el presente contrato. Así mismo, autorizo a ChevyPlan® S.A. a tratar mi información y datos personales con las autoridades anteriormente mencionadas para los efectos previstos en el presente numeral.<br>
                      7. En el evento de haber suscrito el contrato o la cesión de derechos siendo mayor de 14 y menor de 18 años, autorizo a ChevyPlan® S.A. o a quien ésta designe para todo lo previsto en los numerales anteriores a excepción de lo contemplado en el numeral 2 ítem iv y numeral 3. Una vez cumpla 18 años autorizo a ChevyPlan® S.A. o a quien ésta designe para que ejecute lo contemplado en los numerales 1 al 5 sin excepción alguna.<br>
                      8. Manifiesto que la información contenida y suministrada en el presente formulario se sujeta al régimen de Habeas Data y a la política de tratamiento de datos personales de Chevyplan®, la cual se encuentra disponible para mi consulta en la página www.chevyplan.com.co.<br><br>
                      La presentación de esta solicitud, no implica compromiso alguno para ChevyPlan® S.A. en cuanto a la aprobación del análisis de capacidad de pago . Cualquier inexactitud en la información y/o documentos suministrados implicarán su negación definitiva.<br><br>
                      El suscriptor,
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fila 2 -->
            <div class="row justify-content-center form-group mt-3">
              <div class="col-sm-12 col-md-2 col-lg-1 text-right">Firma</div>
              <div class="col-sm-12 col-md-6 col-lg-5"><hr></div>
            </div>
            <!-- Fila 3 -->
            <div class="row justify-content-center form-group mb-4">
              <div class="col-sm-1 col-md-1 col-lg-1" style="min-width: 195px;">
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="NP" formControlName="inName">
                  <label class="form-check-label">En nombre propio</label>
                </div>
              </div>
              <div class="col-sm-1 col-md-1 col-lg-1" style="min-width: 195px;">
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="RL" formControlName="inName">
                  <label class="form-check-label">Representante legal</label>
                </div>
              </div>
              <div class="col-sm-1 col-md-1 col-lg-1" style="min-width: 195px;">
                <div class="form-check">
                  <input class="form-check-input" type="radio" value="A" formControlName="inName">
                  <label class="form-check-label">Apoderado</label>
                </div>
              </div>
            </div>
            <!-- Fila 4 -->
            <div class="row justify-content-center">
              <div class="col-sm-3 col-md-2 col-lg-1 form-group text-md-right text-lg-right">Nombre</div>
              <div class="col-sm-8 col-md-9 col-lg-5 form-group" [ngClass]="{ 'text-danger': name5.invalid && name5.touched }">
                  <input class="form-control form-control-sm"
                  type="text"
                  formControlName="name5"
                  [readonly]="inName.value === 'NP'">
                  <div *ngIf="name5.errors && (name5.dirty || name5.touched)">
                    <span *ngIf="name5.errors.required">Requerido</span>
                  </div>
                </div>
              <div class="col-sm-3 col-md-2 col-lg-1 form-group text-md-right text-lg-right">No. identificación</div>
              <div class="col-sm-8 col-md-9 col-lg-2 form-group" [ngClass]="{ 'text-danger': documentNumber5.invalid && documentNumber5.touched }">
                <input class="form-control form-control-sm"
                type="text"
                formControlName="documentNumber5"
                [readonly]="inName.value === 'NP'" >
                <div *ngIf="documentNumber5.errors && (documentNumber5.dirty || documentNumber5.touched)">
                  <span *ngIf="documentNumber5.errors.required">Requerido</span>
                </div>
              </div>
            </div>
            <!-- Fila 5 -->
            <div *ngIf="inName.value !== 'NP'" class="row justify-content-center mt-4 mb-0">
              <div class="col-sm-3 col-md-2 col-lg-1 form-group text-md-right text-lg-right">De</div>
              <div class="col-sm-8 col-md-9 col-lg-5 form-group"><input class="form-control form-control-sm" type="text" readonly formControlName="thirdName"></div>
              <div class="col-sm-3 col-md-2 col-lg-1 form-group text-md-right text-lg-right">No. identificación</div>
              <div class="col-sm-8 col-md-9 col-lg-2 form-group"><input class="form-control form-control-sm" type="text" readonly formControlName="thirdDocumentNumber" [imask]="onlyNumberMask"></div>
            </div>
          </div>
        <!-- </div> -->
      <!-- </div> -->
      <!-- Separador -->
      <div class="row justify-content-center">
        <hr style="width: 90%; margin-bottom: 1.45rem;">
      </div>
      <!-- Boton Guardar -->
      <div class="row justify-content-center text-center">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <!-- definir que va a hacer despues que envie el formulario -->
          <!-- <button class="btn btn-primary font-weight-bold m-2" title="Guardar" [disabled]="forma.disabled">
            <i class="fa fa-save"></i>
            Guardar
          </button> -->
          <button type="button" class="btn btn-primary font-weight-bold m-2" title="Volver" (click)="onBack()">
              <i class="fas fa-arrow-left"></i>
              Volver
          </button>
          <button class="btn btn-primary font-weight-bold m-2" type="button" (click)="onSave()" [disabled]="forma.disabled || formSubmitted">
            <i class="fa fa-save"></i>
            Guardar
          </button>
          <!-- <button class="btn btn-primary font-weight-bold m-2" title="Enviar" [disabled]="forma.disabled || formSubmitted">
            <i class="fas fa-paper-plane"></i>
            Enviar
          </button> -->
          <button class="btn btn-primary font-weight-bold m-2" type="submit" title="Firma" [disabled]="forma.disabled || formSubmitted">
            <i class="fa fa-pencil"></i>
            Firma digital
          </button>
        </div>
      </div>
    </form>
    <!-- <ngx-spinner color="#c2af85" size="medium" type="ball-fussion">
      <p class='color-spinner-text'>Cargando... </p>
  </ngx-spinner> -->
  </div>
</div>

<ngx-spinner color="#c2af85" size="medium" type="ball-fussion">
  <p class='color-spinner-text'>Cargando... </p>
</ngx-spinner>
